var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"width":"766px","height":"478px","visible":_vm.tipDialog,"title":_vm.tipTitle},on:{"close":_vm.close}},[_c('img',{attrs:{"src":_vm.tipUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }